import script from "./TransportIcons.vue?vue&type=script&setup=true&lang=js"
export * from "./TransportIcons.vue?vue&type=script&setup=true&lang=js"

import "./TransportIcons.vue?vue&type=style&index=0&id=bdfba560&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bdfba560"]])

export default __exports__